import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import Filter from '@/components/Filter';
import {
  fetchRoles,
  updateRolesFilter,
  updateRolesFlags,
} from '../actions';
import RolesFilterToggles from '../components/RolesFilterToggles';

const RolesFilters = ({
  assignable,
  category,
  userFlag,
  tokenFlag,
  updateFlags,
  filterTerm,
  updateFilterTerm,
  fetchData,
  readErrors,
  className,
  fluid,
  hideFlags,
}) => {
  const label = hideFlags ? undefined : (
    <RolesFilterToggles
      userFlag={userFlag}
      tokenFlag={tokenFlag}
      updateFlags={(includeUsers, includeTokens) => updateFlags(category, includeUsers, includeTokens, assignable)}
    />
  );

  return (
    <Filter
      fluid={fluid}
      className={clsx('aridhia-roles-filter', className)}
      filterTerm={filterTerm}
      updateFilter={({ value }) => updateFilterTerm(category, value)}
      error={firstErrorMessage(readErrors)}
      onFilter={() => fetchData(category, 1, null, false)}
      label={label}
    />
  );
};

const mapStateToProps = ({
  roles: { roles },
}, { category }) => {
  const {
    filter, userFlag, tokenFlag, assignable, readErrors,
  } = roles[category];

  return (
    {
      assignable,
      filterTerm: filter,
      tokenFlag,
      userFlag,
      readErrors,
    }
  );
};

const mapDispatchToProps = {
  fetchData: fetchRoles,
  updateFilterTerm: updateRolesFilter,
  updateFlags: updateRolesFlags,
};

export default connect(mapStateToProps, mapDispatchToProps)(RolesFilters);
